// extracted by mini-css-extract-plugin
export default {"tablaAgregado":"CrudAsociarSeriesCobradoresComponent_tablaAgregado__wSeLN","tablaSiCoincide":"CrudAsociarSeriesCobradoresComponent_tablaSiCoincide__v9cfX"};